import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";
import { z } from "zod";

export const referralEligibility = z.object({
  type: z.literal("referral-eligibility"),
  id: z.string(),
  attributes: z.object({
    referralProgram: z.string(),
    eligible: z.boolean(),
    bonusAmount: z.number().optional(),
    ineligibilityReason: z.string().optional(),
    ineligibilityMessage: z.string().optional(),
  }),
});

export const getReferralEligibilityResponse = z.object({
  data: z.array(referralEligibility),
});

export type ReferralEligibility = z.infer<typeof referralEligibility>;
export type GetReferralEligibilityResponse = z.infer<typeof getReferralEligibilityResponse>;

function getReferralsEligibilityV2Url(workerId?: string): string {
  return `${environmentConfig.REACT_APP_BASE_API_URL}/v2/referrals-eligibility/${workerId ?? ""}`;
}

export function useReferralsEligibilityV2(
  params: { workerId?: string | undefined },
  options: UseGetQueryOptions<GetReferralEligibilityResponse> = {}
): UseQueryResult<GetReferralEligibilityResponse | undefined> {
  const { workerId } = params;
  return useGetQuery({
    url: getReferralsEligibilityV2Url(workerId),
    responseSchema: getReferralEligibilityResponse,
    enabled: isDefined(workerId),
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_REFERRALS_ELIGIBILITY_V2_FAILURE,
    },
    ...options,
  });
}
